import {
  UserLogActionType,
  type UserLogsFilter,
} from '@/modules/graphql/codegen/graphql'

export const USER_LOG_SEARCH_MAX_LENGTH = 500
export const USER_LOG_ACTION_TYPES = Object.values(UserLogActionType)

export type UserLogRouteFilters = {
  from?: string
  to?: string
  actionTypes?: UserLogActionType[]
  search?: string
}

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

export function parseUserLogCalendarDate(value: string) {
  const match = DATE_ONLY_PATTERN.exec(value)
  if (!match) return undefined

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const date = new Date(year, month - 1, day)

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return undefined
  }

  return date
}

export function formatUserLogCalendarDate(date: Date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function userLogDateRangeToFilter(from?: string, to?: string) {
  if (!from) return {}

  const start = parseUserLogCalendarDate(from)
  const end = parseUserLogCalendarDate(to ?? from)
  if (!start || !end) return {}

  const exclusiveEnd = new Date(end)
  exclusiveEnd.setDate(exclusiveEnd.getDate() + 1)

  return {
    from: start.toISOString(),
    to: exclusiveEnd.toISOString(),
  }
}

export function userLogRouteFiltersToGraphQL({
  from,
  to,
  actionTypes,
  search,
}: Readonly<UserLogRouteFilters>): UserLogsFilter | undefined {
  const dateRange = userLogDateRangeToFilter(from, to)
  const normalizedSearch = search?.trim()
  const filter: UserLogsFilter = {
    ...dateRange,
    ...(actionTypes?.length ? { actionTypes } : {}),
    ...(normalizedSearch ? { search: normalizedSearch } : {}),
  }

  return Object.keys(filter).length > 0 ? filter : undefined
}
